import EspaBanner from './EspaBanner';

export default EspaBanner;
